module.exports = ".map {\n  height: 870px;\n  width: 70%;\n  margin-top: 10px;\n  margin-right: 0;\n  margin-left: 5px;\n  float: left;\n  border: 1px solid lightgray; }\n\n.sidebar {\n  height: 870px;\n  width: 27.5%;\n  float: right;\n  margin: 10px;\n  padding: 0px 10px;\n  border: 1px solid lightgray;\n  overflow-y: auto;\n  overflow-x: hidden; }\n\n.control-label {\n  text-align: left; }\n\nlabel {\n  overflow-x: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/locations/insert/point/point-insert.component.scss
// module id = ./src/app/locations/insert/point/point-insert.component.scss
// module chunks = main